import { useTypedQuery } from "hooks";
import { DevicesDashboardQueryKeys } from "modules/DevicesDashboard/queryKeys";
import { ApiInstance } from "utils/Api";

import type { DropdownItemProps } from "components";

const formatModels = (models: string[]): DropdownItemProps<string>[] => models.map(model => ({ key: model, value: model, text: model }));

export const useModelsQuery = () =>
  useTypedQuery({
    queryKey: DevicesDashboardQueryKeys.models,
    queryFn: async ({ baseUrl, endpoint }) => (await ApiInstance.get(endpoint, baseUrl)).data.models,
    select: formatModels
  });
